import $ from 'jquery';

const defaults = {
  source: '.field-image.c1 img',
  target: '.field-image.c1 a',
};

export default class BackgroundImage {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.addBackgroundImage();
    this.ready();
  }

  getSource() {
    return this.$element.find(this.settings.source).attr('src');
  }

  addBackgroundImage() {
    const src = this.getSource();
    if (src && src.length) {
      this.$element.find(this.settings.target)
        .css('background-image', `url(${src})`)
        .addClass('bgi');
    }
  }

  ready() {
    this.$element.addClass('ready');
  }
}
